import React from "react";
import { HiOutlineTicket } from "react-icons/hi";

export interface TicketsPoolInlineProps {
  remaining: number;
  /** Tylko dla dostępnego slotu — badge wybranych w koszyku */
  selectedInBasket?: number;
}

const TicketsPoolInline: React.FC<TicketsPoolInlineProps> = ({ remaining, selectedInBasket = 0 }) => (
  <div className="ticket-left flex-center-center">
    {remaining}
    <HiOutlineTicket className="alert-icon" />
    {selectedInBasket > 0 && <div className="ticket-selected-count">{selectedInBasket}</div>}
  </div>
);

export default TicketsPoolInline;
